export class RiskLevelFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<RiskLevel>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<RiskLevel>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RiskLevelFilters.attributeTypeMap;
    }
    constructor() {
    }
}
